import { render, staticRenderFns } from "./program_head.vue?vue&type=template&id=4588f7d8&scoped=true&"
import script from "./program_head.vue?vue&type=script&lang=js&"
export * from "./program_head.vue?vue&type=script&lang=js&"
import style0 from "./program_head.vue?vue&type=style&index=0&id=4588f7d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4588f7d8",
  null
  
)

export default component.exports